import { ICommand } from 'core-ts-types';
import { APUserModeAPIStrategy } from './../strategies/user_mode_api_strategy';
angular
  .module('capability-ng-academic-planner')
  .service('loadAcademicPlanForAdvisor', function loadAcademicPlanForAdvisor(loadAcademicPlanCommand: ICommand) {
    return async () => {
      try {
        await loadAcademicPlanCommand();
        return true;
      } catch (er) {
        if (er.status === 400) {
          await loadAcademicPlanCommand(APUserModeAPIStrategy['student'].AP_PLAN_API_URL);
          return true;
        }
        return false;
      }
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/load_ap_for_advisor_command.ts